// extracted by mini-css-extract-plugin
export default {"option":"ButtonOptions_option__wHWS5","selected":"ButtonOptions_selected__A9gHb"};